import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { mostraAlertaError, mostraAlertaOk } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from "../../../../componentes/contenedores/Card";
import { IdentificarEstacion } from "../../../../componentes/estacion/Estacion";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizardBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import { CajaVerificar, CompraPagoAnulada, ComprasAnulada, ComprasListar, ProveedoresListar, CompraFiltro } from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { ImprimirCompra } from "./ImprimirCompras";
import ReporteCompra from "./ReporteCompras";
import { pdf } from '@react-pdf/renderer';
import Swal from "sweetalert2";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import MetodosPagoDinamicos from "../../../../componentes/metodos/MetodosPagos";

const HomeEditarCompras = () => {
    const { usuario } = useContextUsuario();
    const { ActualizarLista, setListaProveedores, listaProveedores, setListaComprasFiltradas } = useContextEmpleado();
    const [compraSeleccionada, setCompraSeleccionada] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [descripcionAnulacion, setDescripcionAnulacion] = useState("");
    const [descripcionAnulacion2, setDescripcionAnulacion2] = useState("");
    const refEdicion = useRef(null);
    const [efectivo, setEfectivo] = useState(0);
    const [totalRecibido, setTotalRecibido] = useState(0);
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [montosPos, setMontosPos] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});
    const [cajaId, setCajaId] = useState(null);
    const [cajaAbierta, setCajaAbierta] = useState(false);
    const [documentoFiltro, setDocumentoFiltro] = useState("FA");
    const [documentoFiltroTemp, setDocumentoFiltroTemp] = useState("FA");
    const [estadoFiltro, setEstadoFiltro] = useState("TODOS");
    const [estadoFiltroTemp, setEstadoFiltroTemp] = useState("TODOS");
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(
        moment().subtract(1, "days").format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
    const proveedores = listaProveedores || [];
    const [proveedorId, setProveedorId] = useState("");
    const [modalProveedorOpen, setModalProveedorOpen] = useState(false);
    const [proveedorSearchTerm, setProveedorSearchTerm] = useState("");
    const [selectedEvent, setSelectedEvent] = useState({});
    const [incluirEmpleado, setIncluirEmpleado] = useState(true);

    const [comprasFiltradas, setComprasFiltradas] = useState([]);

    const verificarYCargarCaja = async () => {
        try {
            const estacionDatos = await IdentificarEstacion();
            const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
            if (response.data.estado === "CE") {
                mostraAlertaError("La caja ya está cerrada. No se puede registrar compras.");
                return;
            }
            const caja = response.data;
            setCajaId(caja.id);
            setCajaAbierta(caja.estado !== "CE");
            return true;
        } catch (error) {
            ErroresPeticion(error);
            return false;
        }
    };

    const [datosPago, setDatosPago] = useState({
        recibido: totalRecibido,
        tipoVenta: "Contado",
        documento: "FA",
        efectivo: [
            { monto: 500 }
        ],
        transferencia: [
            { monto: 1000, referencia: "900700027760", cuentaId: 1 }
        ],
        tarjeta: [
            { monto: 700, referencia: "900700027760", posId: 1 }
        ],
        montoCredito: 0,
        fecha: "",
        fechaVencimiento: "",
        saldo: 0,
    });

    useEffect(() => {
            if (!Array.isArray(listaProveedores) || listaProveedores.length === 0) {
                ActualizarLista(ProveedoresListar, setListaProveedores);
            }
        }, [ActualizarLista, listaProveedores, setListaProveedores]);

    useEffect(() => { }, [datosPago]);


    const actualizarListaPagos = () => {
        let tipoPagoValido = "Efectivo";

        if (totalRecibido > 0) {
            if (parseFloat(efectivo) > 0 && transferencias === 0 && pos === 0) {
                tipoPagoValido = "Efectivo";
            } else if (transferencias > 0 && pos === 0) {
                tipoPagoValido = "Transferencia";
            } else if (pos > 0 && transferencias === 0) {
                tipoPagoValido = "Tarjeta";
            } else {
                tipoPagoValido = "Mixto";
            }
        }

        let tipoVenta = "Contado";
        if (datosPago.documento === "CR") {
            tipoVenta = "Crédito";
        }

        let nPago = {
            pago: Total,
            recibido: totalRecibido,
            tipo: tipoPagoValido,
            documento: datosPago.documento,
            tipoVenta: tipoVenta,
            fecha: moment().format("YYYY-MM-DD"),
            efectivo:
                parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
        };

        const listaTransferencias = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));

        if (listaTransferencias.length > 0) {
            nPago = { ...nPago, transferencia: listaTransferencias };
        }

        const listaPos = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));

        if (listaPos.length > 0) {
            nPago = { ...nPago, tarjeta: listaPos };
        }

        setDatosPago(nPago);
    };

    useEffect(() => {
        const nuevoTotal = parseFloat(pos) + parseFloat(transferencias) + parseFloat(efectivo);
        if (nuevoTotal !== totalRecibido) setTotalRecibido(nuevoTotal);
        actualizarListaPagos();
        verificarYCargarCaja();
    }, [pos, transferencias, efectivo, totalRecibido]);

    const limpiarDatosPago = () => {
        setEfectivo(0);
        setTotalRecibido(0);
        setPos(0);
        setTransferencias(0);
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
        setModalOpen(false);
        setModalOpen2(false);
        setDescripcionAnulacion2("");
    };

    const handleSeleccionarCompra = (compra) => {
        setCompraSeleccionada(compra);
        setTimeout(() => {
            refEdicion.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
    };

    const handleImprimirCompra = (compra) => {
        ImprimirCompra(compra);
    };

    const confirmarAnulacion = async () => {
        if (!compraSeleccionada) return;
        if (!descripcionAnulacion.trim()) {
            mostraAlertaError("Debe ingresar una descripción para la anulación.", "Error");
            return;
        }
        try {
            await AxiosPrivado.post(ComprasAnulada, {
                compraId: compraSeleccionada.id,
                fechaHora: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                estado: "Anulada",
                empleadoId: usuario.datoPersonales.id,
                descripcion: descripcionAnulacion,
            });
            mostraAlertaOk("Compra anulada correctamente.", "Éxito");
            ActualizarLista(ComprasListar, setListaComprasFiltradas);
            setModalOpen(false);
            setDescripcionAnulacion("");
            setCompraSeleccionada(null);
            setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
        } catch (error) {
            console.error("Error al anular la compra:", error);
            mostraAlertaError(
                error.response?.data?.message || "Error al anular la compra.",
                "Error"
            );
        }
    };

    const Total = compraSeleccionada?.totalCompra || 0;
    const validarPago = (esCredito, total, pos, trans, efectivo, recibido, pagos, pagoId) => {
        const totalTarjetaYTransf = pos + trans;
        if (!esCredito) {
            if (totalTarjetaYTransf > total) {
                mostraAlertaError("El monto pagado con tarjeta o transferencia no puede exceder el total de la compra.", "Pago inválido");
                return false;
            }
            const exceso = recibido - total;
            const efectivoRequerido = total - totalTarjetaYTransf;
            if (exceso > 0 && efectivo < efectivoRequerido) {
                mostraAlertaError("El cambio solo puede generarse si el exceso proviene del efectivo.", "Pago inválido");
                return false;
            }
        } else {
            const pagadoSinEste = pagos?.filter(p => p.estado !== "Anulada" && p.id !== pagoId)
                ?.reduce((sum, p) => sum + parseFloat(p.recibido || 0), 0) || 0;
            const saldoActual = total - pagadoSinEste;
            if (recibido > saldoActual) {
                if (totalTarjetaYTransf > saldoActual) {
                    mostraAlertaError("El monto pagado con tarjeta o transferencia no puede exceder el saldo pendiente.", "Pago inválido");
                    return false;
                }
                const exceso = recibido - saldoActual;
                const efectivoRequerido = saldoActual - totalTarjetaYTransf;
                if (efectivo < efectivoRequerido) {
                    mostraAlertaError("El cambio solo puede generarse si el exceso proviene del efectivo.", "Pago inválido");
                    return false;
                }
            }
        }
        return true;
    };

    const validarReferencias = () => {
        let hayError = false;

        let nuevosErroresPos = {};
        let nuevosErroresTransferencia = {};

        Object.keys(montosPos).forEach(posId => {
            if (parseFloat(montosPos[posId] || 0) > 0) {
                const ref = referenciasPos[posId] || "";
                if (!/^\d{6,15}$/.test(ref)) {
                    nuevosErroresPos[posId] = "La referencia debe tener entre 6 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        Object.keys(montosTransferencia).forEach(cuentaId => {
            if (parseFloat(montosTransferencia[cuentaId] || 0) > 0) {
                const ref = referenciasTransferencia[cuentaId] || "";
                if (!/^\d{8,15}$/.test(ref)) {
                    nuevosErroresTransferencia[cuentaId] = "La referencia debe tener entre 8 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        setErroresReferenciaPos(nuevosErroresPos);
        setErroresReferenciaTransferencia(nuevosErroresTransferencia);

        if (hayError) {
            mostraAlertaError("Hay referencias inválidas. Verifica los campos marcados.", "Error de validación");
        }

        return !hayError;
    };

    const generarListaTransferencias = () => {
        const lista = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));
        return lista;
    };

    const generarListaPos = () => {
        const lista = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));
        return lista;
    };

    const confirmarAnulacionPago = async () => {
        if (!validarReferencias()) return;
        const esCredito = compraSeleccionada?.creditocompras?.length > 0;
        const totalCompra = parseFloat(compraSeleccionada?.totalCompra || 0);
        const efectivoNum = (datosPago.efectivo || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const posNum = (datosPago.tarjeta || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const transferenciaNum = (datosPago.transferencia || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const totalRecibidoNum = efectivoNum + posNum + transferenciaNum;
        const saldoRequerido = saldoAntesDelUltimoPago;
        const pagoViejo = ultimoPago;
        const compraId = compraSeleccionada?.id;
        if (totalRecibidoNum <= 0) {
            return mostraAlertaError("Debe ingresar al menos un método de pago válido.", "Error");
        }
        if (!esCredito && totalRecibidoNum < saldoRequerido) {
            return mostraAlertaError(
                `El monto total recibido (${formatoMoneda(totalRecibidoNum)}) es menor al saldo pendiente (${formatoMoneda(saldoRequerido)}). Para una venta al contado (no crédito), el pago debe cubrir el total.`,
                "Pago Insuficiente"
            );
        }
        if (!cajaId) return mostraAlertaError("Caja no autenticada");
        // Para anular un pago la caja tiene que estar abierta. La condicion
        // anterior estaba invertida y, al no asignarse nunca la bandera,
        // nunca se disparaba: venia copiada de HomeApertura.
        if (!cajaAbierta) return mostraAlertaError("La caja no está abierta. No se puede anular el pago.");
        if (descripcionAnulacion2.trim().length < 10) return mostraAlertaError("Ingrese una descripción detallada del motivo de anulación.");
        if (pagoYaAnulado) return mostraAlertaError("Este pago ya fue anulado. No puede repetirse el proceso.");
        if (!pagoViejo?.id || !compraId) return mostraAlertaError("No se encontró información válida del pago o compra.");
        if (!validarPago(esCredito, totalCompra, posNum, transferenciaNum, efectivoNum, totalRecibidoNum, compraSeleccionada?.pagocompras, pagoViejo.id)) {
            return;
        }
        const nuevoPago = {
            fecha: moment().toISOString(),
            pago: totalRecibidoNum,
            recibido: totalRecibidoNum,
            documento: pagoViejo.documento,
            cajaId,
            estado: "Completada",
            compraId,
            efectivo: efectivoNum,
            transferencia: generarListaTransferencias(),
            tarjeta: generarListaPos()
        };
        try {
            await AxiosPrivado.post(CompraPagoAnulada, {
                pagoId: pagoViejo.id,
                fechaHora: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
                empleadoId: usuario.datoPersonales.id,
                descripcion: descripcionAnulacion2,
                pago: nuevoPago,
            });
            mostraAlertaOk("Pago anulado y reemplazado correctamente.");
            ActualizarLista(ComprasListar, setListaComprasFiltradas);
            setCompraSeleccionada(null);
            setModalOpen(false);
            limpiarDatosPago();
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
            const msjError =
                error?.response?.data?.msj ||
                error?.response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            mostraAlertaError(msjError);
        }
    };

    const handleImprimirReporteCompras = async (compra) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        if (compra) {
            try {
                const blob = await pdf(<ReporteCompra compra={compra} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `ReporteCompra_${compra.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };

    const columnas = useMemo(() => [
        { title: "ID", data: "id" },
        {
            title: "Proveedor",
            data: "proveedor",
            render: (proveedor) => {
                return proveedor && proveedor.nombre
                    ? proveedor.nombre
                    : "Sin proveedor";
            },
        },
        {
            title: 'Fecha',
            data: null,
            render: (rowData) => {
                const fechaStr =
                    rowData.facturacompras?.[0]?.fecha ||
                    rowData.recibocompras?.[0]?.fecha ||
                    rowData.creditocompras?.[0]?.fecha;
                if (fechaStr) {
                    const fecha = moment(fechaStr);
                    return fecha.isValid() ? fecha.format('DD/MM/YYYY') : '—';
                }
                return '—';
            },
        },
        {
            title: "Tipo Compra",
            data: null,
            render: (row) => {
                if (row.creditocompras?.length > 0) return "Crédito";
                if (row.facturacompras?.length > 0 || row.recibocompras?.length > 0)
                    return "Contado";
                return "—";
            },
        },
        {
            title: "Documento",
            data: null,
            render: (row) => {
                return row.pagoCompras?.[0]?.pago?.documento || "—";
            },
        },
        {
            title: "Estado",
            data: "estado",
            render: (data) => {
                let badgeClass = "";
                switch (data) {
                    case "Completada":
                        badgeClass = "bg-success text-white";
                        break;
                    case "Anulada":
                        badgeClass = "bg-info text-white";
                        break;
                    case "Pendiente":
                        badgeClass = "bg-warning text-dark";
                        break;
                    default:
                        badgeClass = "bg-secondary text-white";
                }
                return `<span class="badge ${badgeClass}">${data || '—'}</span>`;
            },
        },
        {
            title: "Total (L)",
            data: "totalCompra",
            render: (data) => {
                const valorFormateado = formatoMoneda(data);
                return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
            }
        },
        {
            title: "Acciones",
            data: null,
            orderable: false,
            className: "dt-center all",
            actions: [
                {
                    key: "ver",
                    className: "btn btn-outline-primary btn-sm",
                    icon: "fas fa-eye",
                    title: "Ver Detalles",
                    onClick: (rowData) => handleSeleccionarCompra(rowData)
                },
                {
                    key: "imprimir",
                    className: "btn btn-outline-info btn-sm",
                    icon: "fas fa-print",
                    title: "Imprimir",
                    onClick: (rowData) => handleImprimirCompra(rowData)
                },
                {
                    key: "imprimirReporteCompras",
                    className: "btn btn-outline-success btn-sm my-1",
                    icon: "fas fa-chart-bar",
                    title: "Reporte de Venta",
                    onClick: (rowData) => handleImprimirReporteCompras(rowData)
                }
            ]
        }
    ], []);

    const datos = {
        titulo: {
            titulo: "Gestion de compras",
            url: "/app/admin/compras/gestion",
            tituloUrl: "Menu gestion",
            nombreUrl: "Edición",
        },
    };

    useEffect(() => {
    const obtenerComprasFiltradas = async () => {
        try {
            const params = new URLSearchParams();

            if (selectedEvent?.proveedorId) {
                params.append("proveedorId", selectedEvent.proveedorId);
            }

            if (incluirEmpleado && usuario?.datoPersonales?.id) {
                params.append("empleadoId", usuario.datoPersonales.id);
            }

            const response = await AxiosPrivado.get(`${CompraFiltro}?${params.toString()}`);

            if (!Array.isArray(response.data)) {
                setComprasFiltradas([]);
                return;
            }

            let compras = response.data;

            const filtroProveedorId = selectedEvent?.proveedorId;
            const filtroEmpleadoId =
                incluirEmpleado && usuario?.datoPersonales?.id
                    ? usuario.datoPersonales.id
                    : null;

            const startTimestamp = fechaInicio
                ? moment(fechaInicio).startOf("day").valueOf()
                : null;

            const endTimestamp = fechaFin
                ? moment(fechaFin).endOf("day").valueOf()
                : null;

            compras = compras.filter((v) => {
                if (filtroProveedorId && Number(v.proveedorId) !== Number(filtroProveedorId)) {
                    return false;
                }

                if (filtroEmpleadoId && Number(v.empleadoId) !== Number(filtroEmpleadoId)) {
                    return false;
                }

                if (estadoFiltro !== "TODOS" && v.estado !== estadoFiltro) {
                    return false;
                }

                if (startTimestamp || endTimestamp) {
                    const fechaStr =
                        v.facturacompras?.[0]?.fecha ||
                        v.recibocompras?.[0]?.fecha ||
                        v.creditocompras?.[0]?.fecha;

                    if (!fechaStr) {
                        return false;
                    }

                    const compraTimestamp = moment(fechaStr).valueOf();

                    if (startTimestamp && compraTimestamp < startTimestamp) {
                        return false;
                    }

                    if (endTimestamp && compraTimestamp > endTimestamp) {
                        return false;
                    }
                }

                if (documentoFiltro !== "TODOS") {
                    if (documentoFiltro === "FA") {
                        return v.facturacompras?.length > 0;
                    }

                    if (documentoFiltro === "RE") {
                        return v.recibocompras?.length > 0;
                    }

                    if (documentoFiltro === "CR") {
                        return v.creditocompras?.length > 0;
                    }

                    return false;
                }

                return true;
            });

            setComprasFiltradas(compras);

        } catch (error) {
            console.error(error);
            mostraAlertaError("Error al obtener las compras.", "Error");
            setComprasFiltradas([]);
        }
    };

    obtenerComprasFiltradas();

}, [
    selectedEvent?.proveedorId,
    incluirEmpleado,
    usuario?.datoPersonales?.id,
    fechaInicio,
    fechaFin,
    estadoFiltro,
    documentoFiltro,
    proveedorId
]);

    const filteredProveedores = proveedores.filter((proveedor) =>
        proveedor.nombre
            .toLowerCase()
            .includes(proveedorSearchTerm.toLowerCase())
    );

    const handleProveedorSeleccionado = (proveedor) => {
        setSelectedEvent((prev) => ({
            ...prev,
            proveedorId: proveedor.id,
            proveedorNombre: proveedor.nombre,
        }));
        setModalProveedorOpen(false);
    };

    const handleFiltrar = () => {
        setDocumentoFiltro(documentoFiltroTemp);
        setEstadoFiltro(estadoFiltroTemp);
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setFechaInicio(moment().format("YYYY-MM-DD"));
        setFechaFin(moment().format("YYYY-MM-DD"));
        setProveedorId("");
        setSelectedEvent({});
        setIncluirEmpleado(false);
        setDocumentoFiltro("FA");
        setDocumentoFiltroTemp("FA");
        setEstadoFiltro("TODOS");
        setEstadoFiltroTemp("TODOS");
        setPanelAbierto(false);
    };

    const ultimoPago = useMemo(() => {
        if (!compraSeleccionada) return null;
        return compraSeleccionada.pagoCompras
            ?.filter(pv => pv.pago?.estado !== "Anulada" && parseFloat(pv.pago?.recibido) > 0)
            ?.map(pv => pv.pago)
            ?.sort((a, b) => new Date(b.fecha) - new Date(a.fecha))[0];
    }, [compraSeleccionada]);

    const pagoYaAnulado = useMemo(() => {
        if (!compraSeleccionada) return false;
        return compraSeleccionada.pagoCompras?.some(pv => pv.pago?.estado === "Anulada") || false;
    }, [compraSeleccionada]);

    const pagosValidos = useMemo(() => {
        if (!compraSeleccionada) return [];
        return compraSeleccionada.pagoCompras
            ?.filter(pv => pv.pago && pv.pago.estado !== "Anulada")
            ?.map(pv => pv.pago)
            ?.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)) || [];
    }, [compraSeleccionada]);

    const totalCompra = useMemo(() => {
        return parseFloat(compraSeleccionada?.totalCompra || 0);
    }, [compraSeleccionada]);

    const saldoAntesDelUltimoPago = useMemo(() => {
        if (pagosValidos.length > 1) {
            const pagosSinUltimo = pagosValidos.slice(0, -1);
            const acumuladoSinUltimo = pagosSinUltimo.reduce(
                (sum, p) => sum + parseFloat(p.recibido || 0),
                0
            );
            return totalCompra - acumuladoSinUltimo;
        } else if (pagosValidos.length === 1) {
            return totalCompra;
        }
        return totalCompra;
    }, [pagosValidos, totalCompra]);

    const esCompraCredito = useMemo(() => compraSeleccionada?.creditocompras?.length > 0, [compraSeleccionada]);

    const calcularCambio = useMemo(() => {
        const recibidoNuevo =
            parseFloat(efectivo || 0) +
            parseFloat(pos || 0) +
            parseFloat(transferencias || 0);

        if (esCompraCredito) {
            return 0;
        }

        return Math.max(recibidoNuevo - saldoAntesDelUltimoPago, 0);

    }, [efectivo, pos, transferencias, saldoAntesDelUltimoPago, esCompraCredito]);

    const [paginaActualProveedor, setPaginaActualProveedor] = useState(1);
    const proveedoresPorPagina = 5;
    const indexUltimoProveedor = paginaActualProveedor * proveedoresPorPagina;
    const indexPrimeroProveedor = indexUltimoProveedor - proveedoresPorPagina;
    const proveedoresPagina = filteredProveedores.slice(indexPrimeroProveedor, indexUltimoProveedor);
    const totalPaginasProveedor = Math.ceil(filteredProveedores.length / proveedoresPorPagina);

    return (
        <Page datos={datos}>
            <Card>
                <div className="mb-4 d-flex justify-content-end">
                    <div className="position-relative">
                        <button
                            className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                            onClick={() => setPanelAbierto(!panelAbierto)}
                            style={{
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "0.9rem",
                                minWidth: "140px",
                            }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="fas fa-filter mx-2"></i>
                                Filtros
                            </span>
                            <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                        </button>

                        {panelAbierto && (
                            <div
                                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                                style={{
                                    minWidth: "240px",
                                    right: 0,
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    padding: "15px",
                                    zIndex: 1050,
                                }}
                            >

                                <div className="mb-3">
                                    <label className="form-label">Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fecha fin</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Proveedor</label>
                                    <div className="d-flex align-items-center">
                                        {selectedEvent.proveedorNombre ? (
                                            <span className="text-success fw-bold">{selectedEvent.proveedorNombre}</span>
                                        ) : (
                                            <span className="text-muted">Ninguno seleccionado</span>
                                        )}
                                    </div>
                                    <ModalBootstrap
                                        titulo="Seleccionar proveedor"
                                        nombreBoton="Buscar"
                                        estiloBoton="btn btn-sm btn-outline-primary mt-2"
                                        iconBoton="fa-solid fa-magnifying-glass"
                                        modalIsOpen={modalProveedorOpen}
                                        setModalIsOpen={setModalProveedorOpen}
                                    >
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar cliente..."
                                                value={proveedorSearchTerm}
                                                onChange={(e) => setProveedorSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped table-hover shadow-smr">
                                                <thead className="bg-dark text-white">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Nombre</th>
                                                        <th>Agregar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {proveedoresPagina.length > 0 ? (
                                                        proveedoresPagina.map((proveedor) => (
                                                            <tr key={proveedor.id}>
                                                                <td>{proveedor.id}</td>
                                                                <td>{proveedor.nombre}</td>
                                                                <td className="text-center align-middle">
                                                                    <button
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() =>
                                                                            handleProveedorSeleccionado(proveedor)
                                                                        }
                                                                    >
                                                                        <i className="fa-regular fa-square-check" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted">
                                                                No se encontraron proveedores.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <nav className="mt-2">
                                                <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                                    <li className={`page-item ${paginaActualProveedor === 1 ? "disabled" : ""}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => setPaginaActualProveedor(paginaActualProveedor - 1)}
                                                            aria-label="Anterior"
                                                        >
                                                            <i className="fas fa-chevron-left me-1"></i> Anterior
                                                        </button>
                                                    </li>
                                                    {[...Array(totalPaginasProveedor)].map((_, i) => (
                                                        <li
                                                            key={i}
                                                            className={`page-item ${paginaActualProveedor === i + 1 ? "active" : ""}`}
                                                        >
                                                            <button className="page-link fw-bold" onClick={() => setPaginaActualProveedor(i + 1)}>
                                                                {i + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${paginaActualProveedor === totalPaginasProveedor ? "disabled" : ""}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => setPaginaActualProveedor(paginaActualProveedor + 1)}
                                                            aria-label="Siguiente"
                                                        >
                                                            Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </ModalBootstrap>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="documentoFiltroSelect" className="form-label fw-bold">Documento</label>
                                    <select
                                        id="documentoFiltroSelect"
                                        className="form-control form-control-sm"
                                        value={documentoFiltroTemp}
                                        onChange={(e) => setDocumentoFiltroTemp(e.target.value)}
                                    >
                                        <option value="FA">Facturas</option>
                                        <option value="RE">Recibos</option>
                                        <option value="CR">Créditos</option>
                                        <option value="TODOS">Todos</option>
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="estadoFiltroSelect" className="form-label fw-bold">Estado</label>
                                    <select
                                        id="estadoFiltroSelect"
                                        className="form-control form-control-sm"
                                        value={estadoFiltroTemp}
                                        onChange={(e) => setEstadoFiltroTemp(e.target.value)}
                                    >
                                        <option value="TODOS">Todos</option>
                                        <option value="Completada">Completada</option>
                                        <option value="Anulada">Anulada</option>
                                    </select>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                        <i className="fas fa-filter mx-1"></i> Filtrar
                                    </button>
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                        <i className="fas fa-sync-alt mx-1"></i> Reset
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tablas
                    datos={comprasFiltradas}
                    columnas={columnas}
                    id="tablaComprasFiltradas"
                />
            </Card>
            {compraSeleccionada && (
                <div ref={refEdicion} className="mt-4">
                    <Card
                        className="p-4 shadow-lg rounded"
                        pie={
                            <>
                                {!(compraSeleccionada.compranuladas && compraSeleccionada.compranuladas.length > 0) ? (
                                    <ModalBootstrap
                                        titulo={`Anular Compra #${compraSeleccionada?.id || "..."}`}
                                        modalIsOpen={modalOpen}
                                        setModalIsOpen={setModalOpen}
                                        nombreBoton="Anular compra"
                                        estiloBoton="btn btn-danger"
                                        iconBoton="fas fa-ban"
                                        pie={
                                            <button className="btn btn-warning" onClick={confirmarAnulacion}>
                                                Confirmar
                                            </button>
                                        }
                                    >
                                        <div className="mb-3">
                                            <label className="form-label fw-bold">Motivo de anulación</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={descripcionAnulacion}
                                                onChange={(e) => setDescripcionAnulacion(e.target.value)}
                                            />
                                        </div>

                                    </ModalBootstrap>
                                ) : (
                                    <div className="alert alert-danger mx-2" role="alert">
                                        <i className="fas fa-ban mx-2"></i> Esta compra ya ha sido Anulada.
                                    </div>
                                )}
                                {pagosValidos.length > 0 && !compraSeleccionada?.compranuladas?.length ? (
                                    ultimoPago ? (
                                        <ModalWizardBootstrap
                                            titulo={`Proceso de anulación y nuevo pago para compra #${compraSeleccionada?.id || "..."
                                                }`}
                                            modalIsOpen={modalOpen2}
                                            setModalIsOpen={setModalOpen2}
                                            nombreBoton="Anular pago"
                                            estiloBoton="btn btn-warning mx-3"
                                            iconBoton="fas fa-exchange-alt mx-2"
                                            iconos={[
                                                "fas fa-ban",
                                                "fas fa-money-check",
                                                "fas fa-check-circle",
                                            ]}
                                            onFinish={confirmarAnulacionPago}
                                            pasos={[
                                                {
                                                    etiqueta: "Anulacion",
                                                    contenido: (
                                                        <>
                                                            {compraSeleccionada?.compranuladas?.length > 0 ? (
                                                                <div className="text-center">
                                                                    <p>Esta venta ya ha sido anulada.</p>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div className="mb-3">
                                                                        <label className="form-label fw-bold">
                                                                            Motivo de anulación
                                                                        </label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            rows="2"
                                                                            value={descripcionAnulacion2}
                                                                            onChange={(e) =>
                                                                                setDescripcionAnulacion2(e.target.value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    ),
                                                },
                                                {
                                                    etiqueta: "Nuevo Pago",
                                                    contenido: (
                                                        <>
                                                            <MetodosPagoDinamicos
                                                                esCompra={true}
                                                                efectivo={efectivo}
                                                                setEfectivo={setEfectivo}
                                                                montosPos={montosPos}
                                                                setMontosPos={setMontosPos}
                                                                referenciasPos={referenciasPos}
                                                                setReferenciasPos={setReferenciasPos}
                                                                erroresReferenciaPos={erroresReferenciaPos}
                                                                setErroresReferenciaPos={setErroresReferenciaPos}
                                                                montosTransferencia={montosTransferencia}
                                                                setMontosTransferencia={setMontosTransferencia}
                                                                referenciasTransferencia={referenciasTransferencia}
                                                                setReferenciasTransferencia={setReferenciasTransferencia}
                                                                erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                                                                setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                                                                pos={pos}
                                                                setPos={setPos}
                                                                transferencias={transferencias}
                                                                setTransferencias={setTransferencias}
                                                                formatoMoneda={formatoMoneda}
                                                                totalConRecargo={saldoAntesDelUltimoPago}
                                                                totalRecibido={totalRecibido}
                                                            />

                                                            <div className="alert alert-warning mt-3">
                                                                <i className="fas fa-info-circle mx-2"></i>
                                                                El saldo pendiente a pagar es de: <strong>{formatoMoneda(saldoAntesDelUltimoPago)}</strong>
                                                            </div>
                                                            <div className="alert alert-info">
                                                                <i className="fas fa-calculator mx-2"></i>
                                                                Total Recibido: <strong>{formatoMoneda(totalRecibido)}</strong> |
                                                                Cambio: <strong>{formatoMoneda(calcularCambio)}</strong>
                                                            </div>
                                                        </>
                                                    ),
                                                },
                                                {
                                                    etiqueta: "Confirmación",
                                                    contenido: (
                                                        <div className="text-center">
                                                            <i className="fas fa-check-circle fa-3x text-success mb-2" />
                                                            <p>¡Todo listo para un nuevo pago!</p>
                                                        </div>
                                                    ),
                                                },
                                            ]}
                                        />
                                    ) : null
                                ) : null}
                            </>
                        }
                    >
                        {compraSeleccionada.compraDetalles?.length > 0 ? (
                            <div className="row justify-content-center">
                                <div className="col-12 p-0 border rounded shadow-sm">
                                    <div className="bg-gray text-white text-start py-3 rounded-top">
                                        <h4 className="mb-0 fw-light mx-4">Informe de movimiento de compra</h4>
                                        <p className="mb-0 text-whit mx-4">ID de Compra: <strong className="text-white">{compraSeleccionada.id || 'N/A'}</strong></p>
                                    </div>
                                    <div className="p-4">
                                        <h5 className="border-bottom pb-2 mb-3 text-primary">Detalle de productos adquiridos</h5>
                                        <div className="table-responsive">
                                            <table className="table table-sm table-striped table-bordered mb-4">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th className="text-center" style={{ width: '10%' }}>#</th>
                                                        <th className="text-end" style={{ width: '15%' }}>Producto</th>
                                                        <th className="text-end" style={{ width: '15%', textAlign: 'right' }}>Cantidad</th>
                                                        <th className="text-end" style={{ width: '20%', textAlign: 'right' }}>Costo unitario (L)</th>
                                                        <th className="text-end" style={{ width: '20%', textAlign: 'right' }}>Subtotal (L)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {compraSeleccionada.compraDetalles.map((detalle, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>{detalle.producto?.nombre || "Sin nombre"}</td>
                                                            <td className="text-end" style={{ textAlign: 'right' }}>{detalle.cantidad}</td>
                                                            <td className="text-end text-muted" style={{ textAlign: 'right' }}>
                                                                {formatoMoneda(parseFloat(detalle.costo))}
                                                            </td>
                                                            <td className="text-end fw-bold" style={{ textAlign: 'right' }}>
                                                                {formatoMoneda(detalle.cantidad * parseFloat(detalle.costo))}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row mt-4 g-3">
                                            <div className="col-12 col-lg-6">
                                                <h5 className="border-bottom pb-2 mb-3 text-success">Resumen de totales</h5>
                                                {(() => {
                                                    const totalCompraCalculado = compraSeleccionada.compraDetalles.reduce((t, item) => t + item.cantidad * parseFloat(item.costo), 0);
                                                    const totalPagado = compraSeleccionada.pagoCompras
                                                        ?.filter(p => p.pago && p.pago.estado !== "Anulada")
                                                        .reduce((sum, p) => sum + parseFloat(p.pago.recibido || 0), 0) || 0;
                                                    const saldoPendiente = Math.max(totalCompraCalculado - totalPagado, 0);
                                                    return (
                                                        <ul className="list-group list-group-flush border rounded">
                                                            <li className="list-group-item d-flex justify-content-between py-2">
                                                                <span className="fw-bold text-dark">Total neto de la compra:</span>
                                                                <span className="fw-bolder text-primary h5">{formatoMoneda(totalCompraCalculado)}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between py-2 bg-light">
                                                                <span className="text-muted">Monto abonado / pagado:</span>
                                                                <span className="fw-bold text-success">{formatoMoneda(totalPagado)}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between py-2">
                                                                <span className="fw-bolder h5 text-dark">SALDO PENDIENTE:</span>
                                                                <span className={`fw-bolder h4 ${saldoPendiente > 0 ? 'text-danger' : 'text-success'}`}>
                                                                    {formatoMoneda(saldoPendiente)}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    );
                                                })()}
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                {compraSeleccionada.pagoCompras
                                                    ?.filter(item => item.pago?.estado !== "Anulada").length > 0 && (
                                                        <>
                                                            <h5 className="border-bottom pb-2 mb-3 text-secondary">Movimientos de pago</h5>
                                                            {(() => {
                                                                // Función para obtener líneas de pago detalladas por método (Efectivo, Tarjeta, Transferencia)
                                                                const obtenerLineasDePagoDetalladas = (pagoCompraItem, indice) => {

                                                                    const lineas = [];
                                                                    const datosBase = {
                                                                        fecha: pagoCompraItem.pago.fecha,
                                                                        documento: pagoCompraItem.pago.documento || `Abono #${indice + 1}`,
                                                                        pagoId: pagoCompraItem.pago.id,
                                                                    };

                                                                    let detalleEncontrado = false;

                                                                    // 1. Efectivo: VERDE
                                                                    pagoCompraItem.pago.pagoefectivos?.forEach((efectivo, idx) => {
                                                                        detalleEncontrado = true;
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-efectivo-${idx}`,
                                                                            metodo: "Efectivo",
                                                                            monto: parseFloat(efectivo.monto || 0),
                                                                            cssClass: 'text-success' // Color verde
                                                                        });
                                                                    });

                                                                    // 2. Tarjeta (POS): AZUL ESTÁNDAR
                                                                    pagoCompraItem.pago.pagotarjeta?.forEach((tarjeta, idx) => {
                                                                        detalleEncontrado = true;
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-tarjeta-${idx}`,
                                                                            metodo: "Tarjeta (POS)",
                                                                            monto: parseFloat(tarjeta.monto || 0),
                                                                            cssClass: 'text-primary' // Color azul
                                                                        });
                                                                    });

                                                                    // 3. Transferencia: NARANJA/AMARILLO (Contraste con Tarjeta)
                                                                    pagoCompraItem.pago.pagotransferencia?.forEach((transferencia, idx) => {
                                                                        detalleEncontrado = true;
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-transferencia-${idx}`,
                                                                            metodo: "Transferencia",
                                                                            monto: parseFloat(transferencia.monto || 0),
                                                                            cssClass: 'text-warning' // Color naranja
                                                                        });
                                                                    });

                                                                    // Caso de reserva: Si no se desglosó el método, pero hay un monto pagado
                                                                    const montoPagoPrincipal = parseFloat(pagoCompraItem.pago.pago || 0);
                                                                    if (!detalleEncontrado && montoPagoPrincipal > 0) {
                                                                        lineas.push({
                                                                            ...datosBase,
                                                                            key: `${pagoCompraItem.pago.id}-generico-0`,
                                                                            metodo: "Pago Genérico (Sin desglose)",
                                                                            monto: montoPagoPrincipal,
                                                                            cssClass: 'text-secondary' // Color gris
                                                                        });
                                                                    }

                                                                    return lineas;
                                                                };

                                                                // 1. Filtrar los pagos no anulados, ordenar por fecha, y 'aplanar' los detalles
                                                                const todasLasLineasDePago = compraSeleccionada.pagoCompras
                                                                    .filter(item => item.pago?.estado !== "Anulada")
                                                                    .sort((a, b) => new Date(a.pago.fecha) - new Date(b.pago.fecha))
                                                                    // Utilizamos flatMap para generar una sola lista con todas las líneas detalladas
                                                                    .flatMap((pagoCompraItem, indice) => obtenerLineasDePagoDetalladas(pagoCompraItem, indice));

                                                                // 2. Renderizar todas las líneas de pago detalladas
                                                                return (
                                                                    <div className="list-group">
                                                                        {todasLasLineasDePago.map(linea => (
                                                                            <div key={linea.key} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    {/* Información del pago principal */}
                                                                                    <small className="text-muted d-block">{moment(linea.fecha).format("YYYY-MM-DD HH:mm")}</small>
                                                                                    <span className="fw-bold me-2">{linea.documento}</span>

                                                                                    {/* Método de pago específico */}
                                                                                    <span className="badge bg-secondary mx-2">{linea.metodo}</span>
                                                                                </div>
                                                                                {/* Monto pagado con ese método, aplicando formatoMoneda */}
                                                                                <span className={`${linea.cssClass} fw-bolder text-end`}>{formatoMoneda(linea.monto)}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                    {compraSeleccionada.pagoCompras
                                        ?.filter(p => p.pago && p.pago.estado === "Anulada").length > 0 && (
                                            <div className="card-footer bg-light mt-3 py-2 border-top">
                                                <h6 className="text-danger mb-1"><i className="fas fa-ban me-1"></i> Pagos Anulados:</h6>
                                                <ul className="list-unstyled mb-0 mt-1 small">
                                                    {compraSeleccionada.pagoCompras
                                                        .filter(p => p.pago && p.pago.estado === "Anulada")
                                                        .sort((a, b) => new Date(a.pago.fecha) - new Date(b.pago.fecha))
                                                        .map(pagoCompraItem => (
                                                            <li key={pagoCompraItem.pago.id}>
                                                                <span className="text-danger mx-2">
                                                                    {moment(pagoCompraItem.pago.fecha).format("YY-MM-DD HH:mm")}
                                                                </span>
                                                                — Doc: {pagoCompraItem.pago.documento || 'N/A'}
                                                                — Monto: <strong className="text-danger mx-2">{formatoMoneda(parseFloat(pagoCompraItem.pago.recibido || 0))}</strong>
                                                                {pagoCompraItem.pago.pagoanulados?.length > 0 && (
                                                                    <span className="text-muted ms-2">
                                                                        (Motivo: {pagoCompraItem.pago.pagoanulados[0].descripcion || 'Sin especificar'})
                                                                    </span>
                                                                )}
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        )}
                                </div>
                            </div>
                        ) : (
                            <div className="alert alert-info text-center py-4 shadow-sm" role="alert">
                                <h5 className="mb-0">ℹ️ No hay detalles o movimientos de pago registrados para esta compra.</h5>
                            </div>
                        )}
                    </Card>
                </div>
            )}
        </Page>
    );
};

export default HomeEditarCompras;